function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.72827 0C10.4382 0 13.4558 2.95111 13.4558 6.57919C13.4558 8.2909 12.7841 9.85208 11.6849 11.0238L13.8478 13.1345C14.0503 13.3325 14.0509 13.6527 13.8485 13.8507C13.7477 13.9507 13.6143 14 13.4817 14C13.3497 14 13.2171 13.9507 13.1155 13.852L10.9265 11.7173C9.775 12.6191 8.31495 13.1591 6.72827 13.1591C3.01836 13.1591 0 10.2073 0 6.57919C0 2.95111 3.01836 0 6.72827 0ZM6.72827 1.01343C3.5897 1.01343 1.03629 3.50985 1.03629 6.57919C1.03629 9.64853 3.5897 12.1456 6.72827 12.1456C9.86615 12.1456 12.4196 9.64853 12.4196 6.57919C12.4196 3.50985 9.86615 1.01343 6.72827 1.01343Z",
  fill: "white"
});

var SvgIconSearch = function SvgIconSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconSearch.d6d9b864.svg";
export { ForwardRef as ReactComponent };